"use client";

import type { CSSProperties } from "react";
import {
	GlassCard,
	Skeleton,
} from "@/components/design-system/ArtistDesignSystem";

const ROW_COUNT = 6;

const cardStyle: CSSProperties = { padding: 0 };
const rowStyle: CSSProperties = {
	display: "grid",
	gridTemplateColumns: "50px minmax(0, 1fr) auto",
	alignItems: "center",
	gap: "var(--ds-space-md)",
	padding: "var(--ds-space-sm) var(--ds-space-lg)",
};
const copyStyle: CSSProperties = {
	display: "grid",
	gap: 6,
	minWidth: 0,
};
const dividerStyle: CSSProperties = {
	height: 1,
	background: "var(--ds-divider)",
	marginInline: "var(--ds-space-lg)",
};

/**
 * SearchSkeleton — loading placeholder matching iOS `SearchSkeletonView`.
 * Renders a `GlassCard(padding=0)` containing 6 `SearchResultRowSkeleton`
 * rows separated by DS divider strokes. Each row mirrors the track row
 * layout: 50×50 artwork block, two text lines, and a duration line.
 */
export function SearchSkeleton({
	rowCount = ROW_COUNT,
}: Readonly<{ rowCount?: number }>) {
	const rowIds = Array.from(
		{ length: rowCount },
		(_, index) => `search-skeleton-row-${index}`,
	);
	return (
		<div className="search-skeleton" role="status" aria-label="正在搜索">
			<GlassCard style={cardStyle} className="search-skeleton__card">
				{rowIds.map((rowId, index) => (
					<div key={rowId}>
						<div style={rowStyle}>
							<Skeleton shape="rectangle" width={50} height={50} />
							<div style={copyStyle}>
								<Skeleton shape="rectangle" width={160} height={16} />
								<Skeleton shape="rectangle" width={120} height={12} />
							</div>
							<Skeleton shape="rectangle" width={36} height={12} />
						</div>
						{index < rowIds.length - 1 ? (
							<div style={dividerStyle} aria-hidden="true" />
						) : null}
					</div>
				))}
			</GlassCard>
		</div>
	);
}
